import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=cc5c58ea&scoped=true&lang=pug&"
import script from "./Permission.vue?vue&type=script&lang=ts&"
export * from "./Permission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5c58ea",
  null
  
)

export default component.exports